import React from "react"

export const GlowingButtonContainer = ({
	intensity,
	borderGlowEnabled,
	disabled,
	...props
}) => {
	const borderGlow = borderGlowEnabled === true ? true : false

	return (
		<div
			className={`${disabled === true ? "" : "glowing-button"} intensity-${intensity || "medium"} ${borderGlow ? "glowing-button-border-glow" : ""}`}
		>
			{props.children}
			<style>{`
				.glowing-button {
					position: relative;
					z-index: 1;
				}
				
				@keyframes animate-glow {
					0% {
						background-position: 0%;
					}
					100% {
						background-position: 400%;
					}
				}
				
				.glowing-button:before {
					transition: 0.5s;
					content: '';
					position: absolute;
					top: 0px;
					left: 0px;
					right: 0px;
					bottom: 0px;
					z-index: -1;
					background: linear-gradient(90deg, #03a9f4, #416ef4, #3b96ff, #03a9f4);
					background-size: 400%;
					border-radius: 1rem;
					filter: blur(20px);
					animation: animate-glow 8s linear infinite;
				}

				.glowing-button-border-glow:after {
					transition: 0.5s;
					content: '';
					position: absolute;
					top: 1px;
					left: 1px;
					right: 1px;
					bottom: 1px;
					z-index: -1;
					background: linear-gradient(90deg, #03a9f4, #416ef4, #3b96ff, #03a9f4);
					background-size: 4100%;
					border-radius: 0.85rem;
					opacity: 0.8;
					animation: animate-glow 8s linear infinite;
				}

				.glowing-button.intensity-small:before {
					top: 10px;
					left: 10px;
					right: 10px;
					bottom: 10px;
					filter: blur(10px);
				}

				.glowing-button.intensity-medium:before {
					top: 5px;
					left: 5px;
					right: 5px;
					bottom: 5px;
					filter: blur(20px);
				}

				.glowing-button.intensity-large:before {
					top: 0px;
					left: 0px;
					right: 0px;
					bottom: 0px;
					filter: blur(25px);
				}
			`}</style>
		</div>
	)
}
